/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to inches for imperial measurements with 1/16" ticks.`)
};

const es_ruler_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia a pulgadas para medidas imperiales con marcas de 1/16".`)
};

const de_ruler_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wechsle zu Zoll für imperiale Maße mit 1/16"-Strichen.`)
};

const nl_ruler_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schakel naar inches voor imperiale metingen met 1/16"-streepjes.`)
};

const fr_ruler_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passez en pouces pour les mesures impériales avec des graduations de 1/16".`)
};

const it_ruler_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa ai pollici per misure imperiali con tacche da 1/16".`)
};

const pt_br2_ruler_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mude para polegadas para medidas no sistema imperial com marcações de 1/16".`)
};

const pt_ruler_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mude para polegadas para medidas imperiais com traços de 1/16".`)
};

const ja_ruler_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インチに切り替えれば1/16インチ単位のヤード・ポンド法で測定できます。`)
};

const zh_ruler_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换到英寸，以 1/16 英寸的刻度进行英制测量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_ex2", locale)
	if (locale === "en") return en_ruler_ex2(inputs)
	if (locale === "es") return es_ruler_ex2(inputs)
	if (locale === "de") return de_ruler_ex2(inputs)
	if (locale === "nl") return nl_ruler_ex2(inputs)
	if (locale === "fr") return fr_ruler_ex2(inputs)
	if (locale === "it") return it_ruler_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_ex2(inputs)
	if (locale === "pt") return pt_ruler_ex2(inputs)
	if (locale === "ja") return ja_ruler_ex2(inputs)
	return zh_ruler_ex2(inputs)
};